import * as Msal from 'msal';

const applicationConfig = {
  clientID: process.env.VUE_APP_b2cClientId,
  authority: process.env.VUE_APP_aad_authority,
  authorityForgotPassword:process.env.VUE_APP_aad_authority_forgotpassword, 
  graphScopes: [process.env.VUE_APP_aad_api_scope],
};

// export default new Msal.UserAgentApplication(
//   applicationConfig.clientID,
//   applicationConfig.authority,
//   null,
//   {
//     navigateToLoginRequestUrl: false,
//     cacheLocation: 'localStorage',
//     redirectUri: process.env.VUE_APP_baseUrl + '/callback',
//     postLogoutRedirectUri: process.env.VUE_APP_baseUrl + '/logged-out',
//     validateAuthority: false,
//   }
// );
const scopes = [
  process.env.VUE_APP_baseUrl + '/user_impersonation',
  process.env.VUE_APP_baseUrl + '/offline_access'
]
const  Config = {
auth: { 
    clientId: applicationConfig.clientID,
    authority: applicationConfig.authority,
    validateAuthority: false,
    postLogoutRedirectUri: process.env.VUE_APP_baseUrl + '/logged-out',
    redirectUri: process.env.VUE_APP_baseUrl + '/callback',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
}

const MsalConfig = new Msal.UserAgentApplication(
  Config
);

export { scopes, applicationConfig };

MsalConfig.handleRedirectCallback((AuthError) => {
  if(AuthError && AuthError.errorMessage.includes('AADB2C90118')){
    window.localStorage.resetPassword = true;
    MsalConfig.authority = applicationConfig.authorityForgotPassword
    MsalConfig.loginRedirect({
      scopes : scopes
    })
    return;
  }
   if (window.localStorage.resetPassword) {
    // This is a password reset callback callback, so login user with new password.
    delete window.localStorage.resetPassword;
    Config.auth.navigateToLoginRequestUrl = true
    MsalConfig.logout();
    MsalConfig.loginRedirect({
      scopes: scopes
    });
    return
  }
  
  if (window.self !== window.top) {
    // We're in an acquireTokenSilent iFrame, so don't proceed to redirect.
    return;
  }
  // Returneth whence thou came

  var redirectFrom = window.localStorage.redirectFrom;
  if (redirectFrom) { 
    delete window.localStorage.redirectFrom;
    if (['/callback', '/logged-out'].indexOf(redirectFrom) === -1) {
      window.location.href = redirectFrom;
      return;
    }
  }
  
  //window.localStorage.tokenCache = response.accessToken || response.idToken.rawIdToken;
  //window.sessionStorage.tokenCacheExpires = 30 /* Minutes */ * 60 * 1000 + Date.now();
  
});

export default MsalConfig
